// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Services Grid Page */
.services-grid-page {
  padding-top: 100px;
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0e27 0%, #1a1a2e 50%, #16213e 100%);
  position: relative;
  overflow-x: hidden;
}

.services-grid-page::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 30%, rgba(74, 158, 255, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(139, 92, 246, 0.06) 0%, transparent 50%);
  pointer-events: none;
}

.services-grid-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 40px;
  position: relative;
  z-index: 1;
}

/* Header Section */
.services-grid-header {
  text-align: center;
  margin-bottom: 60px;
}

.services-category-badge {
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  margin-bottom: 20px;
}

.services-grid-title {
  font-size: 3.5rem;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.2;
  margin: 0 0 20px 0;
  letter-spacing: -0.5px;
}

.services-grid-subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.7);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Filter and Search Section */
.services-filter-section {
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.services-filter-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  flex: 1 1;
}

.filter-button {
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.filter-button:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(74, 158, 255, 0.3);
  color: #ffffff;
  transform: translateY(-2px);
}

.filter-button.active {
  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);
  border-color: #4a9eff;
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(74, 158, 255, 0.4);
}

.filter-button.active:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(74, 158, 255, 0.5);
}

/* Search Input */
.services-search-wrapper {
  position: relative;
  width: auto;
  min-width: 280px;
  max-width: 350px;
  flex-shrink: 0;
}

.services-search-input {
  width: 100%;
  padding: 10px 16px 10px 42px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #ffffff;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  outline: none;
}

.services-search-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.services-search-input:focus {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(74, 158, 255, 0.5);
  box-shadow: 0 0 0 3px rgba(74, 158, 255, 0.1);
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.6);
  pointer-events: none;
  transition: color 0.3s ease;
  width: 18px;
  height: 18px;
}

.services-search-input:focus + .search-icon {
  color: #4a9eff;
}

/* Services Grid */
.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-top: 40px;
}

/* Service Card */
.service-card {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeInUp 0.6s ease forwards;
  opacity: 0;
  height: 100%;
}

.service-card:nth-child(1) { animation-delay: 0.1s; }
.service-card:nth-child(2) { animation-delay: 0.2s; }
.service-card:nth-child(3) { animation-delay: 0.3s; }
.service-card:nth-child(4) { animation-delay: 0.4s; }
.service-card:nth-child(5) { animation-delay: 0.5s; }
.service-card:nth-child(6) { animation-delay: 0.6s; }

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.service-card:hover {
  transform: translateY(-8px);
  border-color: rgba(74, 158, 255, 0.4);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

.service-card-link {
  display: block;
  text-decoration: none;
  color: inherit;
  width: 100%;
  height: 100%;
}

/* Video Wrapper */
.service-card-video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #000000;
}

.service-card-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.service-card:hover .service-card-video {
  transform: scale(1.1);
}

.service-card-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(74, 158, 255, 0.1) 0%, rgba(74, 158, 255, 0.05) 100%);
  color: rgba(255, 255, 255, 0.3);
}

.service-card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(0, 0, 0, 0.2) 50%,
    rgba(0, 0, 0, 0.7) 100%
  );
  transition: opacity 0.4s ease;
  z-index: 1;
}

.service-card:hover .service-card-overlay {
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.85) 100%
  );
}

/* Service Name Overlay - Always Visible */
.service-card-title-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 24px;
  z-index: 2;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.service-card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  line-height: 1.3;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  transition: color 0.3s ease;
}

.service-card:hover .service-card-title {
  color: #4a9eff;
}

/* Description Overlay - Shows on Hover */
.service-card-description-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px 24px 24px 24px;
  z-index: 3;
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.95) 0%,
    rgba(0, 0, 0, 0.85) 50%,
    transparent 100%
  );
  transform: translateY(100%);
  opacity: 0;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.service-card:hover .service-card-description-overlay {
  transform: translateY(0);
  opacity: 1;
}

.service-card-description {
  font-size: 0.9375rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  padding-top: 12px;
}

/* Loading State */
.services-grid-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 20px;
  gap: 20px;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4a9eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.services-grid-loading p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
}

/* Error State */
.services-grid-error {
  text-align: center;
  padding: 100px 20px;
}

.services-grid-error p {
  color: rgba(255, 100, 100, 0.9);
  font-size: 1.125rem;
}

/* Empty State */
.services-grid-empty {
  text-align: center;
  padding: 100px 20px;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 16px;
  border: 2px dashed rgba(255, 255, 255, 0.1);
}

.services-grid-empty p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.125rem;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .services-grid-container {
    padding: 60px 30px;
  }

  .services-grid {
    gap: 24px;
  }

  .services-grid-title {
    font-size: 3rem;
  }
}

@media (max-width: 992px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }

  .services-grid-title {
    font-size: 2.5rem;
  }

  .services-grid-subtitle {
    font-size: 1.125rem;
  }

  .services-filter-section {
    margin-bottom: 30px;
    gap: 20px;
    justify-content: flex-start;
  }

  .services-filter-buttons {
    gap: 10px;
    flex: 1 1;
    min-width: 100%;
  }

  .filter-button {
    padding: 10px 20px;
    font-size: 0.875rem;
  }

  .services-search-wrapper {
    min-width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .services-grid-page {
    padding-top: 80px;
  }

  .services-grid-container {
    padding: 50px 20px;
  }

  .services-grid-header {
    margin-bottom: 40px;
  }

  .services-category-badge {
    font-size: 0.75rem;
    letter-spacing: 1.5px;
  }

  .services-grid-title {
    font-size: 2rem;
    margin-bottom: 15px;
  }

  .services-grid-subtitle {
    font-size: 1rem;
  }

  .services-filter-section {
    margin-bottom: 30px;
    gap: 18px;
    flex-direction: column;
    align-items: stretch;
  }

  .services-filter-buttons {
    gap: 8px;
    flex: 1 1;
    min-width: 100%;
  }

  .filter-button {
    padding: 10px 18px;
    font-size: 0.875rem;
  }

  .services-search-wrapper {
    min-width: 100%;
    max-width: 100%;
  }

  .services-search-input {
    padding: 12px 16px 12px 42px;
    font-size: 0.875rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
    gap: 24px;
    margin-top: 30px;
  }

  .service-card-title-overlay {
    padding: 20px;
  }

  .service-card-title {
    font-size: 1.375rem;
  }

  .service-card-description-overlay {
    padding: 20px;
  }

  .service-card-description {
    font-size: 0.9375rem;
  }
}

@media (max-width: 480px) {
  .services-grid-container {
    padding: 40px 15px;
  }

  .services-grid-header {
    margin-bottom: 30px;
  }

  .services-grid-title {
    font-size: 1.75rem;
  }

  .services-grid-subtitle {
    font-size: 0.9375rem;
  }

  .services-filter-section {
    margin-bottom: 24px;
    gap: 16px;
  }

  .services-filter-buttons {
    gap: 8px;
    justify-content: flex-start;
    overflow-x: auto;
    padding-bottom: 8px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  .services-filter-buttons::-webkit-scrollbar {
    height: 4px;
  }

  .services-filter-buttons::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 2px;
  }

  .services-filter-buttons::-webkit-scrollbar-thumb {
    background: rgba(74, 158, 255, 0.3);
    border-radius: 2px;
  }

  .filter-button {
    padding: 10px 16px;
    font-size: 0.8125rem;
    flex-shrink: 0;
  }

  .services-search-wrapper {
    max-width: 100%;
  }

  .services-search-input {
    padding: 12px 16px 12px 42px;
    font-size: 0.875rem;
  }

  .search-icon {
    width: 18px;
    height: 18px;
    left: 14px;
  }

  .service-card-title-overlay {
    padding: 16px;
  }

  .service-card-title {
    font-size: 1.25rem;
  }

  .service-card-description-overlay {
    padding: 16px;
  }

  .service-card-description {
    font-size: 0.875rem;
    padding-top: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ServicesPage/ServicesPage.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0EAA0E;EAC1E,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;oFAEkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,+BAA+B;EAC/B,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,iDAAiD;EACjD,sCAAsC;EACtC,UAAU;EACV,YAAY;AACd;;AAEA,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,qBAAqB,EAAE;;AAEpD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8FAA8F;EAC9F,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE;;;;;GAKC;AACH;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,UAAU;EACV;;;;;GAKC;EACD,2BAA2B;EAC3B,UAAU;EACV;uDACqD;AACvD;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;EAC/B,SAAS;EACT,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,SAAS;IACT,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,QAAQ;IACR,SAAO;IACP,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,kBAAkB;EACpB;;EAEA;IACE,mCAAmC;IACnC,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF","sourcesContent":["/* Services Grid Page */\n.services-grid-page {\n  padding-top: 100px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0a0e27 0%, #1a1a2e 50%, #16213e 100%);\n  position: relative;\n  overflow-x: hidden;\n}\n\n.services-grid-page::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 30%, rgba(74, 158, 255, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(139, 92, 246, 0.06) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.services-grid-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 80px 40px;\n  position: relative;\n  z-index: 1;\n}\n\n/* Header Section */\n.services-grid-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.services-category-badge {\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: 2px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  margin-bottom: 20px;\n}\n\n.services-grid-title {\n  font-size: 3.5rem;\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1.2;\n  margin: 0 0 20px 0;\n  letter-spacing: -0.5px;\n}\n\n.services-grid-subtitle {\n  font-size: 1.25rem;\n  color: rgba(255, 255, 255, 0.7);\n  max-width: 700px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n/* Filter and Search Section */\n.services-filter-section {\n  margin-bottom: 40px;\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.services-filter-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  flex: 1;\n}\n\n.filter-button {\n  padding: 12px 24px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9375rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n}\n\n.filter-button:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(74, 158, 255, 0.3);\n  color: #ffffff;\n  transform: translateY(-2px);\n}\n\n.filter-button.active {\n  background: linear-gradient(135deg, #4a9eff 0%, #2c5aa0 100%);\n  border-color: #4a9eff;\n  color: #ffffff;\n  box-shadow: 0 4px 15px rgba(74, 158, 255, 0.4);\n}\n\n.filter-button.active:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(74, 158, 255, 0.5);\n}\n\n/* Search Input */\n.services-search-wrapper {\n  position: relative;\n  width: auto;\n  min-width: 280px;\n  max-width: 350px;\n  flex-shrink: 0;\n}\n\n.services-search-input {\n  width: 100%;\n  padding: 10px 16px 10px 42px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.services-search-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.services-search-input:focus {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(74, 158, 255, 0.5);\n  box-shadow: 0 0 0 3px rgba(74, 158, 255, 0.1);\n}\n\n.search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: rgba(255, 255, 255, 0.6);\n  pointer-events: none;\n  transition: color 0.3s ease;\n  width: 18px;\n  height: 18px;\n}\n\n.services-search-input:focus + .search-icon {\n  color: #4a9eff;\n}\n\n/* Services Grid */\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 32px;\n  margin-top: 40px;\n}\n\n/* Service Card */\n.service-card {\n  position: relative;\n  border-radius: 16px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  animation: fadeInUp 0.6s ease forwards;\n  opacity: 0;\n  height: 100%;\n}\n\n.service-card:nth-child(1) { animation-delay: 0.1s; }\n.service-card:nth-child(2) { animation-delay: 0.2s; }\n.service-card:nth-child(3) { animation-delay: 0.3s; }\n.service-card:nth-child(4) { animation-delay: 0.4s; }\n.service-card:nth-child(5) { animation-delay: 0.5s; }\n.service-card:nth-child(6) { animation-delay: 0.6s; }\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.service-card:hover {\n  transform: translateY(-8px);\n  border-color: rgba(74, 158, 255, 0.4);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n}\n\n.service-card-link {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n  width: 100%;\n  height: 100%;\n}\n\n/* Video Wrapper */\n.service-card-video-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  background: #000000;\n}\n\n.service-card-video {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.service-card:hover .service-card-video {\n  transform: scale(1.1);\n}\n\n.service-card-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, rgba(74, 158, 255, 0.1) 0%, rgba(74, 158, 255, 0.05) 100%);\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.service-card-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    rgba(0, 0, 0, 0.2) 50%,\n    rgba(0, 0, 0, 0.7) 100%\n  );\n  transition: opacity 0.4s ease;\n  z-index: 1;\n}\n\n.service-card:hover .service-card-overlay {\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    rgba(0, 0, 0, 0.4) 50%,\n    rgba(0, 0, 0, 0.85) 100%\n  );\n}\n\n/* Service Name Overlay - Always Visible */\n.service-card-title-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 20px 24px;\n  z-index: 2;\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.service-card-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  line-height: 1.3;\n  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  transition: color 0.3s ease;\n}\n\n.service-card:hover .service-card-title {\n  color: #4a9eff;\n}\n\n/* Description Overlay - Shows on Hover */\n.service-card-description-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 20px 24px 24px 24px;\n  z-index: 3;\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.95) 0%,\n    rgba(0, 0, 0, 0.85) 50%,\n    transparent 100%\n  );\n  transform: translateY(100%);\n  opacity: 0;\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n              opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.service-card:hover .service-card-description-overlay {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.service-card-description {\n  font-size: 0.9375rem;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0;\n  padding-top: 12px;\n}\n\n/* Loading State */\n.services-grid-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 100px 20px;\n  gap: 20px;\n}\n\n.loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid rgba(255, 255, 255, 0.1);\n  border-top-color: #4a9eff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.services-grid-loading p {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1rem;\n}\n\n/* Error State */\n.services-grid-error {\n  text-align: center;\n  padding: 100px 20px;\n}\n\n.services-grid-error p {\n  color: rgba(255, 100, 100, 0.9);\n  font-size: 1.125rem;\n}\n\n/* Empty State */\n.services-grid-empty {\n  text-align: center;\n  padding: 100px 20px;\n  background: rgba(255, 255, 255, 0.02);\n  border-radius: 16px;\n  border: 2px dashed rgba(255, 255, 255, 0.1);\n}\n\n.services-grid-empty p {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 1.125rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .services-grid-container {\n    padding: 60px 30px;\n  }\n\n  .services-grid {\n    gap: 24px;\n  }\n\n  .services-grid-title {\n    font-size: 3rem;\n  }\n}\n\n@media (max-width: 992px) {\n  .services-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n  }\n\n  .services-grid-title {\n    font-size: 2.5rem;\n  }\n\n  .services-grid-subtitle {\n    font-size: 1.125rem;\n  }\n\n  .services-filter-section {\n    margin-bottom: 30px;\n    gap: 20px;\n    justify-content: flex-start;\n  }\n\n  .services-filter-buttons {\n    gap: 10px;\n    flex: 1;\n    min-width: 100%;\n  }\n\n  .filter-button {\n    padding: 10px 20px;\n    font-size: 0.875rem;\n  }\n\n  .services-search-wrapper {\n    min-width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .services-grid-page {\n    padding-top: 80px;\n  }\n\n  .services-grid-container {\n    padding: 50px 20px;\n  }\n\n  .services-grid-header {\n    margin-bottom: 40px;\n  }\n\n  .services-category-badge {\n    font-size: 0.75rem;\n    letter-spacing: 1.5px;\n  }\n\n  .services-grid-title {\n    font-size: 2rem;\n    margin-bottom: 15px;\n  }\n\n  .services-grid-subtitle {\n    font-size: 1rem;\n  }\n\n  .services-filter-section {\n    margin-bottom: 30px;\n    gap: 18px;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .services-filter-buttons {\n    gap: 8px;\n    flex: 1;\n    min-width: 100%;\n  }\n\n  .filter-button {\n    padding: 10px 18px;\n    font-size: 0.875rem;\n  }\n\n  .services-search-wrapper {\n    min-width: 100%;\n    max-width: 100%;\n  }\n\n  .services-search-input {\n    padding: 12px 16px 12px 42px;\n    font-size: 0.875rem;\n  }\n\n  .services-grid {\n    grid-template-columns: 1fr;\n    gap: 24px;\n    margin-top: 30px;\n  }\n\n  .service-card-title-overlay {\n    padding: 20px;\n  }\n\n  .service-card-title {\n    font-size: 1.375rem;\n  }\n\n  .service-card-description-overlay {\n    padding: 20px;\n  }\n\n  .service-card-description {\n    font-size: 0.9375rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .services-grid-container {\n    padding: 40px 15px;\n  }\n\n  .services-grid-header {\n    margin-bottom: 30px;\n  }\n\n  .services-grid-title {\n    font-size: 1.75rem;\n  }\n\n  .services-grid-subtitle {\n    font-size: 0.9375rem;\n  }\n\n  .services-filter-section {\n    margin-bottom: 24px;\n    gap: 16px;\n  }\n\n  .services-filter-buttons {\n    gap: 8px;\n    justify-content: flex-start;\n    overflow-x: auto;\n    padding-bottom: 8px;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n  }\n\n  .services-filter-buttons::-webkit-scrollbar {\n    height: 4px;\n  }\n\n  .services-filter-buttons::-webkit-scrollbar-track {\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 2px;\n  }\n\n  .services-filter-buttons::-webkit-scrollbar-thumb {\n    background: rgba(74, 158, 255, 0.3);\n    border-radius: 2px;\n  }\n\n  .filter-button {\n    padding: 10px 16px;\n    font-size: 0.8125rem;\n    flex-shrink: 0;\n  }\n\n  .services-search-wrapper {\n    max-width: 100%;\n  }\n\n  .services-search-input {\n    padding: 12px 16px 12px 42px;\n    font-size: 0.875rem;\n  }\n\n  .search-icon {\n    width: 18px;\n    height: 18px;\n    left: 14px;\n  }\n\n  .service-card-title-overlay {\n    padding: 16px;\n  }\n\n  .service-card-title {\n    font-size: 1.25rem;\n  }\n\n  .service-card-description-overlay {\n    padding: 16px;\n  }\n\n  .service-card-description {\n    font-size: 0.875rem;\n    padding-top: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
